// testimonial slider
document.addEventListener("DOMContentLoaded", function () {
  $(".testimonial-slider").slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });
});

// blogs slider
// document.addEventListener("DOMContentLoaded", function () {
//   $(".blogsSlider").slick({
//     dots: true,
//     arrows: false,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     responsive: [
//       {
//         breakpoint: 1080,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 1,
//         },
//       },
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 2,
//         },
//       },
//     ],
//   });
// });
// blogs slider - desktop only
document.addEventListener("DOMContentLoaded", function () {
  // Check if screen width is desktop size (1024px or larger)
  if (window.innerWidth >= 768) {
    $(".blogsSlider").slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      responsive: [
        {
          breakpoint: 1080,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }
});

// Optional: Handle window resize to destroy/reinitialize slider
window.addEventListener("resize", function () {
  if (window.innerWidth >= 768) {
    // Initialize slider if not already initialized
    if (!$(".blogsSlider").hasClass("slick-initialized")) {
      $(".blogsSlider").slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
          {
            breakpoint: 1080,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  } else {
    // Destroy slider on smaller screens
    if ($(".blogsSlider").hasClass("slick-initialized")) {
      $(".blogsSlider").slick("unslick");
    }
  }
});
